// extracted by mini-css-extract-plugin
module.exports = {"container":"_5b10bb2305--container--Ws0yu"};